import { render, staticRenderFns } from "./TopLeagues.vue?vue&type=template&id=67ceaee8&scoped=true"
import script from "./TopLeagues.vue?vue&type=script&lang=js"
export * from "./TopLeagues.vue?vue&type=script&lang=js"
import style0 from "./TopLeagues.vue?vue&type=style&index=0&id=67ceaee8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ceaee8",
  null
  
)

export default component.exports